import { useEffect, useState } from 'react';
import {
  buildRequestLoadSummaryFromRequests,
  fetchRequestLoadSummaryRequests,
} from './kioskApi';
import {
  createRequestLoadSummaryState,
  isCompletedRequest,
} from './kioskTransforms';

export function useRequestLoadSummary(displayedRequestLoad, displayedRequestLoadRequests, deviceMap) {
  const [requestLoadSummary, setRequestLoadSummary] = useState(() => createRequestLoadSummaryState());

  useEffect(() => {
    if (!displayedRequestLoad?.loadId) {
      setRequestLoadSummary(createRequestLoadSummaryState());
      return;
    }

    if (displayedRequestLoadRequests.length === 0) {
      setRequestLoadSummary(createRequestLoadSummaryState({ status: 'success' }));
      return;
    }

    let active = true;

    async function loadRequestLoadSummary() {
      const completedRequestCount = displayedRequestLoadRequests.filter(isCompletedRequest).length;

      setRequestLoadSummary(createRequestLoadSummaryState({
        requestCount: completedRequestCount,
        requests: displayedRequestLoadRequests,
        status: 'pending',
      }));

      try {
        const requestDetails = await fetchRequestLoadSummaryRequests(displayedRequestLoadRequests, deviceMap);

        if (!active) {
          return;
        }

        setRequestLoadSummary(createRequestLoadSummaryState(buildRequestLoadSummaryFromRequests(requestDetails)));
      } catch (error) {
        if (!active) {
          return;
        }

        setRequestLoadSummary(createRequestLoadSummaryState({
          requestCount: completedRequestCount,
          requests: displayedRequestLoadRequests,
          status: 'error',
          message: error instanceof Error ? error.message : 'Unable to load request load summary.',
        }));
      }
    }

    loadRequestLoadSummary();

    return () => {
      active = false;
    };
  }, [deviceMap, displayedRequestLoad?.loadId, displayedRequestLoadRequests]);

  return requestLoadSummary;
}
